import { createTheme, ThemeOptions } from "@material-ui/core";
import { darkTheme } from "assets/themes/dark-theme";
import {lightTheme} from "../../../assets/themes/light-theme";

export function getHeaderTheme(isLightTheme: boolean): ThemeOptions {
    return isLightTheme ? collectorHeaderLightTheme : collectorHeaderDarkTheme;
}

export const collectorHeaderDarkTheme: ThemeOptions = createTheme({
    ...darkTheme,
    palette: {
        ...darkTheme.palette,
        primary: {
            main: "rgb(43,43,51, 0.7)",
            contrastText: "#EFEFEF",
        },
        secondary: {
            main: "#FE6502",
            contrastText: "#EFEFEF",
        }
    },
    typography: {
        htmlFontSize: 18,
        fontFamily: "Myriad Pro Regular"
    },
    overrides: {
        MuiAppBar: {
            root: {
                boxShadow: "0 3px 10px #00000014",
                minHeight: 65,
                backgroundColor: 'rgb(43,43,51, 0.7) !important',
            },
        },
        MuiToolbar: {
          root: {
              minHeight: 65,
          }
        },
        MuiList: {
            root: {
                display: "inline-flex",
                paddingLeft: 40,
                paddingRight: 40,
                flexGrow: 1,
            }
        },
        MuiLink: {
          root: {
              cursor: "pointer",
          }
        },
        MuiButton: {
            root: {
                borderRadius: 0,
            }
        },
        MuiPopover: {
            root: {
                top: 0,
                maxWidth: '100vw',
                maxHeight: '100vh',
                overflow: 'auto!important',
            },
            paper: {
                position: 'absolute',
                maxWidth: '100vw',
                maxHeight: '100vh',
                overflow: 'auto!important',
                top: '0!important',
                left: '0!important',
                bottom: 0,
                right: 0
            }
        }
    },
});

export const collectorHeaderLightTheme: ThemeOptions = createTheme({
    ...lightTheme,
    palette: {
        ...darkTheme.palette,
        primary: {
            main: "rgb(43,43,51, 0.7)",
            contrastText: "#EFEFEF",
        },
        secondary: {
            main: "#FE6502",
            contrastText: "#EFEFEF",
        },
        background: {
            default: "#FFFFFF",
            paper: "#FFFFFF",
        },
        text: {
            primary: "#383838",
            secondary: "#B2B2B2",
        },
    },
    typography: {
        htmlFontSize: 18,
        fontFamily: "Myriad Pro Regular"
    },
    overrides: {
        MuiAppBar: {
            root: {
                boxShadow: "0 3px 10px #00000014",
                minHeight: 65,
                backgroundColor: '#FFFFFF !important',
            },
        },
        MuiToolbar: {
            root: {
                minHeight: 65,
            }
        },
        MuiList: {
            root: {
                display: "inline-flex",
                paddingLeft: 40,
                paddingRight: 40,
                flexGrow: 1,
            }
        },
        MuiLink: {
            root: {
                cursor: "pointer",
            }
        },
        MuiButton: {
            root: {
                borderRadius: 0,
            }
        },
        MuiPopover: {
            root: {
                top: 0,
                maxWidth: '100vw',
                maxHeight: '100vh',
                overflow: 'auto!important',
            },
            paper: {
                position: 'absolute',
                maxWidth: '100vw',
                maxHeight: '100vh',
                overflow: 'auto!important',
                top: '0!important',
                left: '0!important',
                bottom: 0,
                right: 0
            }
        },
        MuiPaper: {
            root: {
                backgroundColor: "#EFEFEF",
            }
        }
    },
});
